<article id="resources" class="side-padding" aria-labelledby="policy_h2">
  <h2 id="policy_h2">Help and Guides</h2>
  <p>Guidance and support for lecturers, teachers and students.</p>
  <p>
    Find out more about creating assignments with Python notebooks in Noteable, how to use features of the service, and
    common uses of available libraries and packages.
  </p>
  <div class="docs_card_area">
    <section class="docs_card" aria-labelledby="section_9_h3">
      <div class="docs_card_body">
        <h3 id="section_9_h3">A general introduction to Notebooks</h3>
        <p>
          A <a href="/user-guide/">general user-guide</a> to what computational notebooks are, how to use one, what
          tools and things are available, and how they work in Noteable.
        </p>
      </div>
    </section>

    <section class="docs_card" aria-labelledby="section_a_h3">
      <div class="docs_card_body">
        <h3 id="section_a_h3">Lecturers/Tutors</h3>
        <ul>
          <li>
            <a
              href="https://github.com/edina/Exemplars2020/blob/master/TeachingDocs/Quick_Reference_Guides/Assignment_QuickRef.ipynb"
              class="show_icon"
              rel="external"
              >Creating assignments</a
            >
          </li>
          <li>
            <a
              href="https://github.com/edina/Exemplars2020/blob/master/TeachingDocs/Quick_Reference_Guides/MarkDown_QuickRef.ipynb"
              class="show_icon"
              rel="external"
              >Markdown basics</a
            >
          </li>
        </ul>
      </div>
      <div class="card-footer" aria-label="contains link to notebook">
        <p><a href="/faq/" class="red">Frequently asked Questions &gt;</a></p>
      </div>
    </section>

    <section class="docs_card" aria-labelledby="section_b_h3">
      <div class="docs_card_body">
        <h3 id="section_b_h3">Students</h3>
        <ul>
          <li>
            <a
              href="https://github.com/edina/Exemplars2020/blob/master/TeachingDocs/Tutorials/UsingNoteableBeginner.ipynb"
              class="show_icon"
              rel="external"
              >Beginner notebook tutorial</a
            >
          </li>
          <li><a href="/student-guide/">Assignments &ndash; fetching and submitting</a></li>
          <li>
            <a
              href="https://github.com/edina/Exemplars2020/blob/master/TeachingDocs/Quick_Reference_Guides/MarkDown_QuickRef.ipynb"
              class="show_icon"
              rel="external"
              >Markdown basics</a
            >
          </li>
        </ul>
      </div>
      <div class="card-footer" aria-label="contains link to notebook">
        <p><a href="/faq/" class="red">Frequently asked Questions &gt;</a></p>
      </div>
    </section>

    <section class="docs_card" aria-labelledby="section_c_h3">
      <div class="docs_card_body">
        <h3 id="section_c_h3">School Teachers</h3>
        <p>
          Find <a href="/exemplars/#sch_nbs">notebooks and guides</a> on computing science, web development, maths and
          stats topics.
        </p>
      </div>
    </section>

    <section class="docs_card" aria-labelledby="section_d_h3">
      <div class="docs_card_body">
        <h3 id="section_d_h3">Collaboration</h3>
        <p>
          Guide to accessing and working in our <a href="/documentation/collab-editing/">collaborative notebooks</a>.
        </p>
      </div>
    </section>

    <section class="docs_card" aria-labelledby="section_e_h3">
      <div class="docs_card_body">
        <h3 id="section_e_h3">Assignment options</h3>
        <ul>
          <li><a href="/documentation/nbguide/">An introduction to Nbgrader for instructors</a></li>
          <li><a href="/documentation/rubberband/">Rubberband extension</a></li>
        </ul>
      </div>
    </section>

    <section class="docs_card" aria-labelledby="section_f_h3">
      <div class="docs_card_body">
        <h3 id="section_f_h3">Common visualisations</h3>
        <p>
          <a
            href="https://github.com/edina/Exemplars2020/tree/master/TeachingDocs/Tutorials/nbgraderExamples"
            class="show_icon"
            rel="external"
            >Notebooks on common visualisations</a
          >; bokeh, scatter graphs, bar charts, and widgets.
        </p>
      </div>
    </section>
  </div>
</article>
